module.exports = __webpack_public_path__ + "img/productionBase_13.e3d23f00.png";